import React from 'react'
import { useTranslate, required, TextInput, NumberInput, BooleanInput, Form } from 'react-admin'
import SaveIcon from '@mui/icons-material/Save'
import { Dialog, DialogContent, DialogTitle, Box, Button, DialogActions } from '@mui/material'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import LoadingButton from '@mui/lab/LoadingButton'

export const CustomVariableModal = ({
  open,
  handleClose,
  titleModal,
  onSubmit,
  loadingButton,
  defaulValue = undefined,
}) => {
  const translate = useTranslate()
  const postSave = (data, e) => {
    onSubmit && onSubmit(data, e)
  }

  return (
    <Dialog open={open} maxWidth='lg' fullWidth={true}>
      <DialogTitle>{titleModal}</DialogTitle>
      <DialogContent>
        <Form id='post_create_form' warnWhenUnsavedChanges onSubmit={postSave} defaultValues={defaulValue}>
          <Box>
            <EditInputsWrap label={translate('ra.field.name')}>
              <TextInput source='var.label' label='' fullWidth validate={[required()]} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.description')}>
              <TextInput source='var.description' label='' fullWidth multiline rows={5} />
            </EditInputsWrap>
            <Box sx={{ display: 'flex' }}>
              <EditInputsWrap label={translate('ra.field.value')}>
                <NumberInput source='var.value' label='' fullWidth />
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.show_breakdown')}>
                <BooleanInput fullWidth source='var.show' label='' />
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.show_sitio')}>
                <BooleanInput fullWidth source='var.show_sitio' label='' />
              </EditInputsWrap>
            </Box>
          </Box>
        </Form>

        <DialogActions className='dialog-actions' style={{ marginTop: '20px' }}>
          <LoadingButton
            loading={loadingButton}
            variant='contained'
            startIcon={<SaveIcon />}
            form='post_create_form'
            type='submit'
          >
            {translate('ra.action.save')}
          </LoadingButton>
          <Button onClick={handleClose} variant='outlined' color='error'>
            {translate('ra.action.cancel')}
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  )
}
